import { Step, StepLabel, Stepper } from '@mui/material';
import { useState } from 'react';
import UploadFile from './UploadFile';
import { UploadFileResult } from 'hooks/ui/useFileUpload';
import Settings from './Settings';
import Review from './Review';
import { useParams } from 'react-router-dom';
import Page from 'components/new/Page';
import ErrorBoundary from 'components/ErrorBoundary';
import PageLoader from 'components/PageLoader';

enum Steps {
  Upload,
  Settings,
  Review,
}

const stepLabels = {
  [Steps.Upload]: 'Upload',
  [Steps.Settings]: 'Import settings',
  [Steps.Review]: 'Review',
};

const ImportStatement: React.FC = () => {
  const [activeStep, setActiveStep] = useState(Steps.Upload);
  const [dateFormat, setDateFormat] = useState<string>();
  const [uploadedFile, setUploadedFile] = useState<UploadFileResult | null>(
    null,
  );

  const { bankAccountId } = useParams<{ bankAccountId: string }>();

  const handleNextStep = () => {
    setActiveStep(activeStep + 1);
  };

  const handlePreviousStep = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <Page tabTitle="Bank Reconciliation" spacing="lg">
      <Stepper activeStep={activeStep}>
        {Object.values(stepLabels).map((stepLabel) => {
          return (
            <Step key={stepLabel}>
              <StepLabel>{stepLabel}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <ErrorBoundary loader={<PageLoader />}>
        {activeStep === Steps.Upload && (
          <UploadFile
            onFileUpload={setUploadedFile}
            uploadedFile={uploadedFile ?? undefined}
            onNextStep={handleNextStep}
            bankAccountId={bankAccountId}
          />
        )}
        {activeStep === Steps.Settings && !!uploadedFile && (
          <Settings
            uploadedFile={uploadedFile}
            onNextStep={handleNextStep}
            onPreviousStep={handlePreviousStep}
            onDateFormatChange={setDateFormat}
            dateFormat={dateFormat}
            bankAccountId={bankAccountId}
          />
        )}
        {activeStep === Steps.Review && !!uploadedFile && !!dateFormat && (
          <Review
            uploadedFile={uploadedFile}
            dateFormat={dateFormat}
            bankAccountId={bankAccountId}
            onPreviousStep={handlePreviousStep}
          />
        )}
      </ErrorBoundary>
    </Page>
  );
};

export default ImportStatement;
